import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/golfnow.png'


const _hoisted_1 = { class: "vh-100 gradient-custom" }
const _hoisted_2 = { class: "container py-5 h-100" }
const _hoisted_3 = { class: "row d-flex justify-content-center align-items-center h-100" }
const _hoisted_4 = { class: "col-12 col-md-8 col-lg-6 col-xl-5" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "mb-md-5 mt-md-3" }
const _hoisted_8 = { class: "form-outline form-white mb-4 row" }
const _hoisted_9 = { class: "col-sm-9" }
const _hoisted_10 = { class: "form-outline form-white mb-4 row" }
const _hoisted_11 = { class: "col-sm-9" }
const _hoisted_12 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "login-header" }, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    width: "100%"
                  }),
                  _createElementVNode("p", { class: "text-black-50 mb-5" }, " Enter your GolfNow Premier Tee Sheet credentials ")
                ], -1)),
                _createElementVNode("div", _hoisted_8, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", {
                    class: "form-label col-sm-3 col-form-label",
                    for: "typeEmailX"
                  }, "Username", -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      id: "typeEmailX",
                      class: "form-control form-control-lg",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.credentials.email) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.credentials.email]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", {
                    class: "form-label col-sm-3 col-form-label",
                    for: "typePasswordX"
                  }, "Password", -1)),
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      id: "typePasswordX",
                      class: "form-control form-control-lg",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.credentials.password) = $event)),
                      onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.credentials.password]
                    ])
                  ])
                ]),
                (_ctx.errorMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.errorMessage), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn btn-lg btn-primary",
                  type: "submit",
                  disabled: _ctx.isLoading,
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
                }, " Login ", 8, _hoisted_13)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}